import { isLiveVoiceId, LIVE_DEFAULT_VOICE_ID, type LiveVoiceId } from "@rakazo/contracts";

const KEY_PREFIX = "hrokbot.live-voice.";

function storage(): Storage | undefined {
  try {
    return typeof window === "undefined" ? undefined : window.localStorage;
  } catch {
    return undefined;
  }
}

/** The Gemini Live voice chosen for one bot. It is a per-device preference. */
export function liveVoiceForBot(botId: string): LiveVoiceId {
  try {
    const value = storage()?.getItem(`${KEY_PREFIX}${botId}`);
    return isLiveVoiceId(value) ? value : LIVE_DEFAULT_VOICE_ID;
  } catch {
    return LIVE_DEFAULT_VOICE_ID;
  }
}

export function setLiveVoiceForBot(botId: string, voiceId: LiveVoiceId): void {
  try {
    storage()?.setItem(`${KEY_PREFIX}${botId}`, voiceId);
  } catch {
    // Private browsing can refuse storage; the default voice still works.
  }
}
